var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher"},[_c('div',{staticClass:"teacher-list"},_vm._l((_vm.teacherList),function(item){return _c('TeacherCard',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }